export function assertUnreachable(_x: never): never {
  throw new Error("Didn't expect to fall into default case");
}
